import { useState } from 'react';
import { AnnotationRect } from '../types';

export const useMaskState = () => {
  // Mask control state
  const [isMaskMode, setIsMaskMode] = useState(false);
  const [primaryMask, setPrimaryMask] = useState<AnnotationRect | null>(null);
  const [secondaryMask, setSecondaryMask] = useState<AnnotationRect | null>(null);
  const [currentMask, setCurrentMask] = useState<AnnotationRect | null>(null);
  const [isDrawingMask, setIsDrawingMask] = useState(false);
  const [selectedMaskId, setSelectedMaskId] = useState<'primary' | 'secondary' | null>(null);

  const clearAllMasks = () => {
    setPrimaryMask(null);
    setSecondaryMask(null);
    setCurrentMask(null);
    setSelectedMaskId(null);
    setIsDrawingMask(false);
    setIsMaskMode(false);
  };

  return {
    isMaskMode,
    setIsMaskMode,
    primaryMask,
    setPrimaryMask,
    secondaryMask,
    setSecondaryMask,
    currentMask,
    setCurrentMask,
    isDrawingMask,
    setIsDrawingMask,
    selectedMaskId,
    setSelectedMaskId,

    // Utility functions
    clearAllMasks
  };
};